module.exports = __webpack_public_path__ + "static/media/1967_con_sorella_ultima_forografia.d3b3e2a4.jpg";